export function removeJsComments(code) {
    return code.replace(/\/\*[\s\S]*?\*\/|\/\/.*/g, "");
}
export function getBehaviourWithoutComments(behaviour) {
    return removeJsComments(behaviour || "").trim();
}
//# sourceMappingURL=code.js.map